import React from 'react'
import "./color.css"

function RedW() {
    var x = localStorage.getItem("percentage weight")
    return (
        <div className = "red__background">
            {x == "NaN" ? "null": x} 
        </div>
    )
}

export default RedW
